module.exports = __webpack_public_path__ + "static/media/pa.8ab5dfa6.webp";